import React from 'react';
import * as XLSX from 'xlsx';

const GuestTable = ({ passes }) => {
  const downloadExcel = () => {
    const rows = passes.map((p) => ({
      Name: p.guestName || '',
      Email: p.guestEmail || '',
      Phone: p.guestPhone || '',
      Profession: p.profession || '',
      Organization: p.organization || '',
      Country: p.country || '',
      LinkedIn: p.linkedinId || '',
      Event: p.event?.title || '',
      Faculty: p.issuedBy?.name || '',
      Status: p.status || '',
    }));

    const worksheet = XLSX.utils.json_to_sheet(rows);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Guest Data');

    const buffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', 'guest_data.xlsx');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  return (
    <div className="guest-table-container">
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '1rem', alignItems: 'center' }}>
        <h2 style={{ margin: 0 }}>Guest Data</h2>
        <button onClick={downloadExcel} className="btn btn-primary" style={{ padding: '8px 16px', borderRadius: '8px', cursor: 'pointer' }}>
          Download as Excel
        </button>
      </div>
      <div style={{ overflowX: 'auto', borderRadius: '8px', border: '1px solid var(--border)', background: 'var(--surface-1)' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left' }}>
          <thead style={{ background: 'var(--surface-2)', borderBottom: '1px solid var(--border)' }}>
            <tr>
              <th style={{ padding: '12px' }}>Name</th>
              <th style={{ padding: '12px' }}>Email</th>
              <th style={{ padding: '12px' }}>Country</th>
              <th style={{ padding: '12px' }}>Profession</th>
              <th style={{ padding: '12px' }}>Event</th>
              <th style={{ padding: '12px' }}>Faculty</th>
              <th style={{ padding: '12px' }}>Status</th>
            </tr>
          </thead>
          <tbody>
            {passes.map(p => (
              <tr key={p._id} style={{ borderBottom: '1px solid var(--border)' }}>
                <td style={{ padding: '12px' }}>{p.guestName}</td>
                <td style={{ padding: '12px' }}>{p.guestEmail}</td>
                <td style={{ padding: '12px' }}>{p.country}</td>
                <td style={{ padding: '12px' }}>{p.profession}</td>
                <td style={{ padding: '12px' }}>{p.event?.title || 'Unknown Event'}</td>
                <td style={{ padding: '12px' }}>{p.issuedBy?.name || 'Unknown Faculty'}</td>
                <td style={{ padding: '12px' }}>
                  <span style={{ 
                    padding: '4px 8px', 
                    borderRadius: '4px', 
                    fontSize: '0.85rem',
                    background: p.status === 'used' ? 'var(--success-bg, #dcfce7)' : 'var(--surface-3)',
                    color: p.status === 'used' ? 'var(--success-text, #166534)' : 'var(--text-2)'
                  }}>
                    {p.status}
                  </span>
                </td>
              </tr>
            ))}
            {passes.length === 0 && (
              <tr>
                <td colSpan="7" style={{ padding: '24px', textAlign: 'center', color: 'var(--text-3)' }}>
                  No guests found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default GuestTable;
